/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


// *********************************** collection page read more and less description ***********************************************************


$(document).ready(function() {
/**** Dynamic checkout button***/  
//   setInterval(function() { 
//     if($('.saw-cart-total').text().replace("$", "").replace(",","") != ''){
//       var res = $('.saw-cart-total').text().replace("$", "").replace(",","");
//       $('.cstm_checkout').css('display', 'block');
//     }else{
//       var res = $('.saw-cart-original-total').text().replace("$", "").replace(",","");
//     }
 
//     if($('.saw-cart-total').text().replace("$", "").replace(",","") != ''){
//       var res = $('.saw-cart-total').text().replace("$", "").replace(",","");

//     }else{
//       var res = $('.saw-cart-original-total').text().replace("$", "").replace(",","");
//     }

// //console.log(res);
// var iNum = parseInt(res);
// //console.log(iNum);

//   if (iNum > 1500 && $.trim(discnt_text) == ''){
// $('.cstm_checkout').css('display', 'none');
// $('.custom__cart_checkout').css('display', 'block');

// }
    
//  var discnt_text = $(".saw-extra-note").text();
// if($.trim(discnt_text) != ''){
//    if(discnt_text.indexOf("Minimum total") > -1){
//        $('.custom__cart_checkout').css('display', 'none');
//    }else{
//       $('.custom__cart_checkout').css('display', 'block');
//    }
//  }
  
//  },500);


  // customer-tags update startss 

  $(document).on('change', '.quantity__input', function(e) {
  var value = parseInt($(this).val(), 10);
    if (value < 1 || isNaN(value)) {
      $(this).val(1); // Reset to minimum value of 1
    }
  });
  
$(document).on('click', '.tag-update-jtpl', function(e) {
  e.preventDefault();
     $(this).addClass("loader_checkout_btn");
      var dataTag = $(this).attr('data-tag');
      var custID = $(this).parents(".total-wrapper-jtpl").attr("customer-id-tag")
     var cutomerTags = $(this).parents(".total-wrapper-jtpl").attr("customer-tags")
     var cutomerTagsToCheck = $(this).parents(".total-wrapper-jtpl").attr("tags-to-checked")
        setCookieNew("CurrntTier",dataTag,1);
              var data = {
              attributes: {
                  currentTag: dataTag,
              }
          };
       var dataApp = {
    currentTags: cutomerTags,
    updatedTag: dataTag,
    customerID: custID,
    checkedTags: cutomerTagsToCheck,
};
$.ajax({
    url: 'https://jeronone.com/test-server/checkoutextension/Yokkao-customerTags/addTags.php',
    dataType: 'json',
    contentType: 'application/json',
    type: 'POST',
    data: JSON.stringify(dataApp),
    asyn: false,
    success: function(response) {
        console.log(response);
        $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              contentType: 'application/json',
              type: 'POST',
              data: JSON.stringify(data),
             asyn: false,
              complete: function(xhr) {

                  console.log(xhr.responseJSON);
                  location.reload();   
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
      
    },
    error: function(xhr) {
        console.log(xhr.responseText);
    },
});
         
     });





  // customer tags update end
  
  $(document).on("click", ".accordion",function() {
$(this).toggleClass('loader_hide');
$('.accordion').not(this).removeClass('loader_hide');
if ($(this).hasClass("loader_hide")) {
  $("body").addClass('custom_loader');
}
     
    var cstm_url = $(this).attr("data-url");
    var cstm_index = $(this).attr("data-index");
    var this1 = this;
    var $this = $(this);
    $(".accordion").not($(this)).removeClass("active");
     $(".accordion").not($(this)).next().removeAttr("style");

    $this.toggleClass("active");
    $this.next().slideToggle(200);
if($.trim(cstm_url) == "#"){
  $("body").removeClass('custom_loader');
  $this.parents('.accordion-contianer').find('.collection-data-'+cstm_index).html("Please assign collection to this tab!!");
return false;
}
var url = cstm_url+"?view=custom-catalog";

    ///ajax
    $.ajax({
      url: url,
      type: "GET", //send it through get method
      success: function(response) {
// alert(cstm_index);
  $this.parents('.accordion-contianer').find('.collection-data-'+cstm_index).html(response);
        $this.parents('.accordion-contianer').find('.collection-data-'+cstm_index).find("tr.custom_main_count").slice(0, 10).show();
        if ($this.parents('.accordion-contianer').find('.collection-data-'+cstm_index).find("tr.custom_main_count:hidden").length == 0) {
          $this.parents('.accordion-contianer').find('.collection-data-'+cstm_index).find("button.load_more_button").fadeOut('slow');
        }
$("body").removeClass('custom_loader');
           
      
    return false;    
  },
  });
    
  });


 

  
  $(document).on("change keyup", ".quantity__input",function(e) {
  if($(this).val() =="0"){
    $(this).val("1") ;
  }
  });
  
$(document).on("click", "button.load_more_button",function(e) {
  e.preventDefault();
  $(this).parents(".panel").find(".custom_main_count:hidden").slice(0, 10).slideDown();
  if ($(this).parents(".panel").find("tr.custom_main_count:hidden").length == 0) {
    $(this).parents(".panel").find("button.load_more_button").fadeOut('slow');
  }
});


 $(document).on("click", ".accordion-contianer a.Pagination__NavItem.Link.Link--primary",function(e) {
     e.preventDefault();
      var url= $(this).attr("data-pagination");
     var cstm_index = $(".accordion.active").attr("data-index");
      jQuery.ajax({
        type: 'GET',
        url: url,
        dataType: 'html',
        success: function(alt_data){  
             $('.collection-data-'+cstm_index).html(alt_data);
    $("body").removeClass('custom_loader');
        },
      });
  });
  /*** yes button click function ****/
  $(document).on('click','.yes_btn',function(e){
    e.preventDefault();
   var inventory_qty = $.trim($('.inventory_qty',this).attr('data-inventorytoAdd'));
   var selected_product =$(this).parents('.inventory_alert_popup').attr('data-variant');
    $('.quantity__input[data-id="'+selected_product+'"]').val(inventory_qty);
    $(this).parents('.inventory_alert_popup').removeClass('active');
   // $('.all_product_get[data-var-id="'+selected_product+'"]')[0].click();
    if(window.location.href.indexOf('cart') > -1){
      $('form[action="/cart"]').submit();
    }else{
    var main_text1 = $('.all_product_get[data-var-id="'+selected_product+'"]');
    var text = $('.all_product_get[data-var-id="'+selected_product+'"]').attr("data-attr");
    main_text1.text("Adding in Cart...");
     addProduct(selected_product,inventory_qty,main_text1,text);
    }
});
  /*** yes button click function end here ***/
  /*** no button click function ****/
 $(document).on('click','.no_btn',function(e){
    e.preventDefault();
    var selected_product =$(this).parents('.inventory_alert_popup').attr('data-variant');
    $('.quantity__input').removeClass('input--error');
   $(this).parents('.inventory_alert_popup').removeClass('active');
    if(window.location.href.indexOf('cart') > -1){
   var newQTY =parseInt($.trim($('.QuantitySelector__CurrentQuantity1[data-id="'+selected_product+'"]').attr('data-qty')));  
   $('.QuantitySelector__CurrentQuantity1[data-id="'+selected_product+'"]').val(newQTY); 
    }
});
  /*** no button click function end here ***/
  /*** function to addproduct in cart END HERE****/
  
  
      $(document).on("click",".all_product_get",function(event){
       event.preventDefault();
var chkminqty = true;
        $('.inventory_error').removeClass('active');
        $('.quantity__input').removeClass('input--error');
        var text = $(this).attr("data-attr");
         var main_text = $(this).text();
         var main_text1 = $(this);
      var main_pro_id = $(this).attr("data-var-id");
        if( $(this).parents(".custom_main_parent").length > 0){
            var qty_val = $(this).parents(".custom_main_parent").find("input.quantity__input").val();
   
        var max_qty =   $(this).parents(".custom_main_parent").find("input.quantity__input").attr('data-max');
        var check_preOrder = $.trim($(this).parents(".custom_main_parent").find("input.quantity__input").attr('data-preorder'));
     
        }else{
              var qty_val = $(this).parents(".mobile_content_data").find("input.quantity__input").val();
   
        var max_qty =   $(this).parents(".mobile_content_data").find("input.quantity__input").attr('data-max');
        var check_preOrder = $.trim($(this).parents(".mobile_content_data").find("input.quantity__input").attr('data-preorder'));
     
        }
         var total_cart_quantity = 0;
            $.ajax({
            type: 'GET',
            async: false,
            url: "/cart.js",
            dataType: "json",
            success: function(cart) {    
             var items = cart.items;
               console.log(items);
               for(var x=0; x < items.length ; x++){
                 var varr_id = items[x].variant_id;
                 if(varr_id == main_pro_id){
                      total_cart_quantity =  items[x].quantity;          
                 }
               }
               },
            });
        var min_qty_chk = 1;
        console.log(qty_val+"====="+min_qty_chk+"====="+total_cart_quantity)
        if(qty_val < min_qty_chk && total_cart_quantity < min_qty_chk ){
            $(".cart-notificaction-jtpl").html('');
            let row = `<div class="close-cart-notification">X</div>
            <div class="main-cart-item-wrapper-jtpl" style="display:flex;margin-top: -15px;">
            <b>Minimum 1 quantity per product required to place the order</b></div>
                   </div>`;
            $("body").addClass("cart-notification-open");
            $(".cart-notificaction-jtpl").append(row);
            $(".cart-notification-wrapper-jtpl").addClass("cart-open-jtpl");
            $("body").addClass("cart-open-jtpl-overla");
          chkminqty = false;
            return false;
        }

        if(chkminqty == false){
           return false;
        }
     var checkInventory= inventoryCheck(qty_val,max_qty,check_preOrder,main_pro_id,'product');
       
        if(checkInventory == false){
          return false;
        }
        
     $(this).text("Adding in Cart...");   
     addProduct(main_pro_id,qty_val,main_text1,text);
      //location.reload(true);
        return false;
 });

function setVariantsShownCookie(productId) {
  const cookieName = "variants_shown";
  document.cookie =
    cookieName +
    "=" +
    productId +
    "; path=/; max-age=" +
    60 * 60 * 24; // 1 day
}

function removeVariantsShownCookie() {
  const cookieName = "variants_shown";
  document.cookie =
    cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
  
// function setVariantsShownCookie(productId) {
//   let cookieName = "variants_shown";
//   let existing = getCookieNew(cookieName);
//   let ids = existing ? existing.split(",") : [];

//   if (!ids.includes(productId.toString())) {
//     ids.push(productId);
//   }

//   document.cookie =
//     cookieName +
//     "=" +
//     ids.join(",") +
//     "; path=/; max-age=" +
//     60 * 60 * 24; // 1 day
// }

// function removeVariantsShownCookie(productId) {
//   let cookieName = "variants_shown";
//   let existing = getCookieNew(cookieName);
//   if (!existing) return;

//   let ids = existing.split(",").filter((id) => id !== productId.toString());

//   if (ids.length) {
//     document.cookie =
//       cookieName + "=" + ids.join(",") + "; path=/; max-age=" + 60 * 60 * 24;
//   } else {
//     // Clear cookie
//     document.cookie =
//       cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
//   }
// }

    jQuery("body").on("click", ".show-variants", function(ev) {
      ev.preventDefault();
      let product_id = $(this).data("product-id");
      $(".variants-product-id" + product_id).removeClass("p-hidden");
     $(this).find(".cstm_view_options").text("Hide options");
      $(this).removeClass("show-variants").addClass("hide-variants");
      setVariantsShownCookie(product_id);
    });


  
    jQuery("body").on("click", ".hide-variants", function(ev) {
      ev.preventDefault();
      let product_id = $(this).data("product-id");
      $(".variants-product-id" + product_id).addClass("p-hidden");
      $(this).find(".cstm_view_options").text("View options");
   $(this).removeClass("hide-variants").addClass("show-variants");
       removeVariantsShownCookie(product_id);
   
    });
//window.triggerSwymVariantEvent(variant.id); 
/*** inventory check on cart page ***/


$(document).on('click','.QuantitySelector__Button.wholesale-user',function(e){
  e.preventDefault();
$(this).parents('.QuantitySelector').find('.QuantitySelector__CurrentQuantity1').val($(this).attr('data-quantity'));
var qty_val = $(this).parents('.QuantitySelector').find('.QuantitySelector__CurrentQuantity1').val();
var max_qty = $(this).parents('.QuantitySelector').find('.QuantitySelector__CurrentQuantity1').attr('data-max'); 
var check_preOrder = $(this).parents('.QuantitySelector').find('.QuantitySelector__CurrentQuantity1').attr('data-preorder'); 
var main_pro_id = $(this).parents('.QuantitySelector').find('.QuantitySelector__CurrentQuantity1').attr('data-id'); 
  var checkInventory= inventoryCheck(qty_val,max_qty,check_preOrder,main_pro_id,'cart');
        if(checkInventory == false){
          return false;
        }
  
 window.location.href= $(this).attr('data-urlVal');

});

/*** inventory check on cart page END HERE***/
/*** Inventory check on key up ***/

  $(document).on('change',"input.QuantitySelector__CurrentQuantity1",function(e){
   e.preventDefault();
  
    var $this = $(this);
  var qty_val = $(this).val();
  var max_qty = $(this).attr('data-max'); 
  var check_preOrder = $(this).attr('data-preorder'); 
  var main_pro_id = $(this).attr('data-id'); 
    var checkInventory= inventoryCheck(qty_val,max_qty,check_preOrder,main_pro_id,'cart');

     if(checkInventory == false){
            return false;
          }
    if($this.attr('data-href') == undefined){
    var id =   $this.attr('data-line-id');
    var url =  "/cart/change?quantity="+qty_val+"&id="+id;
      window.location.href= url;
    }else{
      window.location.href= $this.attr('data-href');
    }
  });
 
/*** Inventory check on key up END HERE***/


  
/**** Close the popup on click outside ***/
$(".inventory_alert_popup").on("click", function (e) {
        if (!$(e.target).closest(".popup_inner").length) {
      $(this).removeClass('active');
         
        }
  
    });
/**** Close the popup on click outside end here***/   
  $("body").on("click",  '.close-cart-notification', function () {
     
    $("body").removeClass("cart-open-jtpl-overla");
    $("body").removeClass("cart-notification-open");
    $(".cart-notification-wrapper-jtpl").removeClass("cart-open-jtpl")
    });
$("body").on("click",  '.cart-notificaction-jtpl-overlay', function () {
     $(".close-cart-notification").trigger("click")
   // $("span.close.toggle").trigger("click")
    });
  jQuery.getJSON('/cart.js', function(cart) {
   // $(".cart-total-jtpl-float").append("<div class='loader_checkout_btn'></div>");
    var  currency = cart.currency;
        var price = cart.total_price
            price = parseFloat(price)/100;
       //window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : 
       
       var  currencyFormat = window.theme.moneyFormat;
       console.log(currencyFormat);
       // var currency_new = currencyFormat.replace(` `,price);
          if(currencyFormat.indexOf(" ") > -1){
             var currArr = currencyFormat.split(" ");    
          }else{
             var currArr = currencyFormat.split("");
    
          }
                if(currency =="THB"){
             var currency_new = currArr[1]+""+price;           
             }else{
               var currency_new = currArr[0]+""+price;
             }
           $("span.total-quanitity-count-jtpl").html(cart.item_count); 
      $("span.total-cart-check-jtpl").html(currency_new); 
       
    $(".cart-total-jtpl-float").removeClass("bounce-cstm-jtpl")
    $(".loader_checkout_btn").remove();
    });
});

function updateCartDrwaer(){ 

     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true  //this code is for prestige theme, is to refresh the cart
   }));
  return false;
     
}

   function getAccordionDataPrice(){
//$('.accordion').not(this).removeClass('loader_hide');
if ($(".accordion.active").hasClass("loader_hide")) {
  $("body").addClass('custom_loader');
}
     
    var cstm_url = $(".accordion.active").attr("data-url");
    var cstm_index = $(".accordion.active").attr("data-index");
    var this1 = $(".accordion.active");
    var $this = $(".accordion.active");
     console.log(cstm_url+"====="+cstm_index);
     console.log($this);
   // $(".accordion").not($(".accordion.active")).removeClass("active");
    // $(".accordion").not($(".accordion.active")).next().removeAttr("style");

   // $this.toggleClass("active");
  //  $this.next().slideToggle(200);
if($.trim(cstm_url) == "#"){
  $("body").removeClass('custom_loader');
  $this.parents('.accordion-contianer').find('.collection-data-'+cstm_index).html("Please assign collection to this tab!!");
return false;
}
var url = cstm_url+"?view=custom-catalog";

    ///ajax
    $.ajax({
      url: url,
      type: "GET", //send it through get method
      success: function(response) {
// alert(cstm_index);
  $this.parents('.accordion-contianer').find('.collection-data-'+cstm_index).html(response);
        $this.parents('.accordion-contianer').find('.collection-data-'+cstm_index).find("tr.custom_main_count").slice(0, 10).show();
        if ($this.parents('.accordion-contianer').find('.collection-data-'+cstm_index).find("tr.custom_main_count:hidden").length == 0) {
          $this.parents('.accordion-contianer').find('.collection-data-'+cstm_index).find("button.load_more_button").fadeOut('slow');
        }
          var cookieName = "variants_shown";
  var existing = getCookieNew(cookieName);
       if(existing.indexOf(",")> -1){
         var retIDSArr = existing.split(",");
         var ids = retIDSArr[retIDSArr.length - 1];
       }else{
         var ids = existing;
       }
         console.log(ids);
       if(ids){
         console.log($(".show-variants[data-product-id='"+ids+"']"));
         $(".show-variants[data-product-id='"+ids+"']").trigger("click");
         const $target = $(".show-variants[data-product-id='" + ids + "']");
          if ($target.length) {
            $("html, body").animate({
              scrollTop: $target.offset().top - 50
            }, 100); // 600ms scroll speed
          }

       }
$("body").removeClass('custom_loader');
           
      
    return false;    
  },
  });
    
  
  } //function ends

//function start to update cartProgress bar
 function updateCartProgress(){
    $.ajax({
    url: '/cart.js',
    method: 'GET',
    dataType: 'json',
    success: function (cart) {
      console.log(cart,"cart");
      const total = cart.original_total_price / 100; 
      const progressBar = $('#progress-bar');
      const message = $('#progress-message');
      let progress = 0;
      let discountMessage = "";
      let target = 0;

 var currencyFormat = window.theme.moneyFormat;
console.log("currencyFormat", currencyFormat);

var currencyCode = Shopify.currency.active;
console.log("Currency Code:", currencyCode);

      var currencySymbol = currencyFormat.replace(/[^€฿$£]/g, ''); 
console.log("Currency Symbol:", currencySymbol);

      let price = 0;
      let formattedPrice = "";
            
      //  var  currencyFormat = window.theme.moneyFormat;
      //  console.log(currencyFormat);
      // //  var currency_new = currencyFormat
      // // console.log("currency_new",currency_new);
      //     if(currencyFormat.indexOf(" ") > -1){
      //        var currArr = currencyFormat.split(" ");    
      //     }else{
      //        var currArr = currencyFormat.split("");
    
      //     }
      //           if(currency =="THB"){
      //        var currency_new = currArr[1]+""+price;           
      //        }else{
      //          var currency_new = currArr[0]+""+price;
      //        }
      console.log("totalll.."+total);
if(currencySymbol.indexOf("฿") > -1){
if (total === 0) {
        target = 175000;
        price = target - total;
  console.log(target+"===="+total+"====="+price);
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} to get 5% off!`;
      } else if (total <= 175000) {
        target = 175000;
        price = target - total;
      console.log(target+"===="+total+"====="+price);
    progress = (total / 175000) * 25;
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} to get 5% off!`;
      } else if (total <= 370000) {
        target = 370000;
        price = target - total;
        progress = 25 + ((total - 175000) / 175000) * 25;
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} more to get 10% off!`;
      } else if (total <= 700000) {
        target = 700000;
        price = target - total;
        progress = 50 + ((total - 370000) / 370000) * 50;
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} more to get 15% off!`;
      } else {
        progress = 100;
        discountMessage = `Congratulations! You have unlocked a 15% discount!`;
      }
}
else if (currencyCode === "AUD" && currencySymbol.indexOf("$") > -1) { 
    if (total === 0) {
        target = 8000; 
        price = target - total;
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} to get 5% off!`;
    } else if (total <= 8000) { 
        target = 8000;
        price = target - total;
        progress = (total / 8000) * 25;
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} to get 5% off!`;
    } else if (total <= 16000) { 
        target = 16000;
        price = target - total;
        progress = 25 + ((total - 8000) / 8000) * 25;
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} more to get 10% off!`;
    } else if (total <= 35000) { 
        target = 35000;
        price = target - total;
        progress = 50 + ((total - 16000) / 16000) * 50;
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} more to get 15% off!`;
    } else {
        progress = 100;
        discountMessage = `Congratulations! You have unlocked a 15% discount!`;
    }
}
else{
  if (total === 0) {
        target = 5000;
        price = target - total;
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} to get 5% off!`;
      } else if (total <= 5000) {
        target = 5000;
        price = target - total;
        progress = (total / 5000) * 25;
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} to get 5% off!`;
      } else if (total <= 10000) {
        target = 10000;
        price = target - total;
        progress = 25 + ((total - 5000) / 5000) * 25;
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} more to get 10% off!`;
      } else if (total <= 20000) {
        target = 20000;
        price = target - total;
        progress = 50 + ((total - 10000) / 10000) * 50;
        discountMessage = `Add ${currencySymbol}${price.toFixed(2)} more to get 15% off!`;
      } else {
        progress = 100;
        discountMessage = `Congratulations! You have unlocked a 15% discount!`;
      }
}
      


      progress = Math.min(Math.max(progress, 0), 100);
      progress = parseInt(progress);

   
      progressBar.css('width', `${progress}%`);
      message.text(discountMessage);
    },
    error: function () {
      console.error("Failed to fetch cart data.");
    }
 
  });
  }
  //function ends

  /*** function to addproduct in cart ****/
 function addProduct(main_pro_id,qty_val,main_text1,text){
    /*
     var stock = 0;
   var preorder = false;
    stock = main_text1.parents('.quantity__variant').find('.quantity__input').attr("data-inv-qty");
    preorder = main_text1.parents('.quantity__variant').find('.quantity__input').attr("data-preOrder");
   
 var properties ={};
    
   if(stock > 0 ){
      if($.trim(preorder) == 'true' ){
      properties['IN-STOCK'] = stock;
      properties['PRE-ORDER'] = qty_val - stock;
     }else{
        if(qty_val >= stock){
           properties['IN-STOCK'] = stock;     
        }
     }
   }else{
     if($.trim(preorder) == 'true' ){
       properties['PRE-ORDER'] = qty_val;
     }
   }
   // console.log(properties);
   //console.log(stock+"==="+preorder);
   */
    var original_total_price = 0;
   
    jQuery.ajax({  
      type: 'POST',
      url: '/cart/add.js',
      data:{
        id: main_pro_id,
        quantity: qty_val,
     },
      dataType: 'json',
      success: function(productid){
        
            console.log(main_text1);
             main_text1.text("Added To Cart");
         setTimeout(function() {           
           main_text1.text(text);
           //location.href = location.href;
            }, 2500);
         // window.location.href='/cart';
         $("<div class='loader_checkout_btn'></div>").insertBefore(".cart-icon-badge-cstm");
        $(".cart-total-jtpl-float").addClass("bounce-cstm-jtpl")
        
           jQuery.getJSON('/cart.js', function(cart) {
            var items = cart.items;
             currency = cart.currency;
            console.log(cart);
                original_total_price = cart.original_total_price
            original_total_price = parseFloat(original_total_price)/100;
   
           // var currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
           // var cartTotalJtpl = Currency.formatMoney(cart.total_price, currencyFormat)
           // var  Currency.formatMoney(cart.total_price, window.theme.moneyFormat)
   for( var i=0; i < items.length; i++ ){
     if(items[i].id == main_pro_id ){
       $(".cart-notificaction-jtpl").html('');
              let row = `
              <div class="close-cart-notification">X</div>
              <div class="main-cart-item-wrapper-jtpl" style="display:flex;">
              
              <div class="media-notificaton-wrapper-jtpl">
              <img intrinsicsize="250 x 200" class="image-media-jtpl" src="${items[i].image}" style="height:100px">
              </div>
              <div class="cartt-item-jtpl-info">
              <h3 class="h3 cart-item-title">
                ${items[i].product_title} 
               </h4><div class="variant-info-jtpl">`;
       if(items[i].variant_title != null ){
             row +=`  
               <span class="cart-item-var-jtpl">
                <strong>Variant:</strong> ${items[i].variant_title}
                </span>
                <br>`;
       }
             row +=`    <span class="cart-quantity-jtpl">
                   <strong>Quantity:</strong>  ${items[i].quantity}
                  </span>
                  </div>
                     </div>
                     </div>
                     <center style="display:none;"><h2 class="cart-total_price-jtpl">
                    <strong>Cart Total Price:</strong>  <span class="cart-money-jtpl">${cart.total_price}</span>
                    </h2></center>
                     <div class="cart-notification__links">
        <a href="/cart" id="cart-notification-button" class="Button Button--primary">View cart
          </a>
      </div>
                     </div>`
        $("body").addClass("cart-notification-open");
        $(".cart-notificaction-jtpl").append(row);
      //  $(".cart-notification-wrapper-jtpl").addClass("cart-open-jtpl");
     //  $("body").addClass("cart-open-jtpl-overla");
      
           break;
     } 
}
        var price =   $(".cart-money-jtpl").text();
            price = parseFloat(price)/100;
             console.log(price);
            
       //window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : 
       
       var  currencyFormat = window.theme.moneyFormat;
       console.log(currencyFormat);
       // var currency_new = currencyFormat.replace(` `,price);
          if(currencyFormat.indexOf(" ") > -1){
             var currArr = currencyFormat.split(" ");    
          }else{
             var currArr = currencyFormat.split("");
    
          }
                if(currency =="THB"){
             var currency_new = currArr[1]+""+price;           
             }else{
               var currency_new = currArr[0]+""+price;
             }
           
       $(".cart-money-jtpl").html(currency_new);     
             $(".Header__CartCount").html(cart.item_count);
             $(".total-quanitity-count-jtpl").html(cart.item_count);
             
            $("span.total-cart-check-jtpl").html(currency_new); 
             updateCartProgress();
            setTimeout(function() {     
             $(".loader_checkout_btn").remove();
               $(".cart-total-jtpl-float").removeClass("bounce-cstm-jtpl");
                
               if(original_total_price>5000 || original_total_price > 10000 || original_total_price > 20000){
                 getAccordionDataPrice();
               }

              
             }, 1000);
            
          });
         return false;
     },
      error:function(error){
          var error_msg = error.responseJSON.description;
        console.log("hereeeeeeeee");
        console.log(error_msg);
          var stock= 0;
        if(main_text1.parents('.quantity__variant').find('.quantity__input').length > 0){
           var stock = main_text1.parents('.quantity__variant').find('.quantity__input').attr("data-inv-qty");
            console.log(stock);
         
            if(error_msg.indexOf("You can't add more") != -1){
              error_msg  = "We currently have "+stock+" item(s) in the stock. Please reduce the quantity." ;
            }
        }
         main_text1.text(text);
        //alert(error.responseJSON.description);
        $('.inventory_error').addClass('active');
        $('.inventory_error h3').text(error_msg);
        main_text1.parents('.quantity__variant').find('.quantity__input').addClass('input--error');
        //main_text1.parents('td').append('<p class="cart_error error">'+error.responseJSON.description+'</p>');
          // setTimeout(function(){$('.cart_error').remove();},5000)
     }
    }); 
    return false;
  }

  function inventoryCheck(qty_val,max_qty,check_preOrder,main_pro_id,page){
      var total_cart_quantity=0;
   $('.max_qty_preOder .cart_qty').text('');
  $('.max_qty_preOder').attr('data-cart-qty',total_cart_quantity); 
    if(page=='cart'){
       var old_quantity = $(".CartItem__QuantitySelector input.QuantitySelector__CurrentQuantity[data-id='"+main_pro_id+"']").attr("data-qty");
       $('.max_qty_preOder').attr('data-old-qty',old_quantity);
       $('.max_qty').attr('data-old-qty',old_quantity);
    }
        var flag = '0';
    $(".max_qty_preOder").addClass("cart-drawer");
      $.ajax({
  type: 'POST',
  async: false,
  url: "/cart.js",
  dataType: "json",
  success: function(cart) {    
   var items = cart.items;
     console.log(items);
     for(var x=0; x < items.length ; x++){
       var varr_id = items[x].variant_id;
       if(varr_id == main_pro_id){
            total_cart_quantity =  items[x].quantity;          
       }
     }

     
     if(total_cart_quantity > 0 && page != "cart"){
        if(check_preOrder == 'true' && parseInt(max_qty) > 0 ) {
     var cart_remaining =0;
      if(total_cart_quantity <= max_qty){
         var cart_remaining = parseInt(max_qty) - parseInt(total_cart_quantity);
        var remaining_qty = parseInt(qty_val) - parseInt(cart_remaining) ;
      }else if(total_cart_quantity > max_qty){
         var remaining_qty = qty_val ;
      }else{
          var cart_remaining = parseInt(max_qty) - parseInt(total_cart_quantity);
      
         var remaining_qty = parseInt(qty_val) - parseInt(cart_remaining) ;
      }
       //&& total_cart_quantity < qty_val
      if(remaining_qty > 0 ){
         $('.max_qty_preOder').attr('data-cart-qty',total_cart_quantity);    
      
           $('.max_qty_preOder').attr('data-variant',main_pro_id);    
          $('.max_qty_preOder').addClass('active');
          $('.max_qty_preOder .input_qty').text(qty_val);
          $('.max_qty_preOder .inventory_qty').text(max_qty);
      
         $('.max_qty_preOder .remaining_qty').text(remaining_qty);
     
          $('.max_qty_preOder .cart_qty').text(total_cart_quantity +" items(s) are already in cart and");
         $('.max_qty_preOder .inventory_qty').attr('data-inventorytoAdd',qty_val);   
         $('.max_qty').removeClass('active');
          flag = '1';
           if(page =='cart'){
            $('.max_qty .confirmation_box').hide();
             $('.max_qty .cart_confirmation_box').show();
            //$('.QuantitySelector__CurrentQuantity1[data-id="'+main_pro_id+'"]').val(qty_val);
            
          }
      return false;
      }
        }    
      }  
    if(total_cart_quantity > 0 && page =="cart"){
        if(parseInt(qty_val) > parseInt(max_qty) && check_preOrder == 'true' && parseInt(max_qty) > 0 ) {
     var cart_remaining =0;
       
      if(total_cart_quantity <= max_qty){
        //alert("1=="+qty_val+"==="+total_cart_quantity);
         var cart_remaining = max_qty - total_cart_quantity;
        var remaining_qty = parseInt(qty_val) - parseInt(cart_remaining) ;
      }else if(total_cart_quantity > max_qty){
       // alert("2=="+qty_val+"==="+total_cart_quantity);
         var remaining_qty = parseInt(qty_val) - parseInt(total_cart_quantity);
      }else{
       // alert("3=="+qty_val+"==="+total_cart_quantity);
          var cart_remaining = parseInt(max_qty) - parseInt(total_cart_quantity);
      
         var remaining_qty = parseInt(qty_val) - parseInt(cart_remaining) ;
      }
       
      if(remaining_qty > 0 && total_cart_quantity < qty_val){
         $('.max_qty_preOder').attr('data-cart-qty',total_cart_quantity);    
      
           $('.max_qty_preOder').attr('data-variant',main_pro_id);    
          $('.max_qty_preOder').addClass('active');
          $('.max_qty_preOder .input_qty').text(qty_val);
          $('.max_qty_preOder .inventory_qty').text(max_qty);
      
         $('.max_qty_preOder .remaining_qty').text(remaining_qty);
     
         // $('.max_qty_preOder .cart_qty').text(total_cart_quantity +" items(s) are already in cart and");
         $('.max_qty_preOder .inventory_qty').attr('data-inventorytoAdd',qty_val);   
         $('.max_qty').removeClass('active');
          flag = '1';
           if(page =='cart'){
            $('.max_qty .confirmation_box').hide();
             $('.max_qty .cart_confirmation_box').show();
            //$('.QuantitySelector__CurrentQuantity1[data-id="'+main_pro_id+'"]').val(qty_val);
            
          }
      return false;
      }
        }    
      }  
    
      if(flag == '1'){
      return false;
    }
  
  }
});
   /*
   $.ajax({
  type: 'POST',
  async: false,
  url: "/cart.js",
  dataType: "json",
  success: function(cart) {    
   var items = cart.items;
     //console.log(items);
     for(var x=0; x < items.length ; x++){
       var varr_id = items[x].variant_id;
       if(varr_id == main_pro_id){
            total_cart_quantity =  items[x].quantity;          
       }
     }

      $('.max_qty_preOder').attr('data-cart-qty',total_cart_quantity);    
        
     if(total_cart_quantity > 0){
    if(parseInt(qty_val) > parseInt(max_qty) && check_preOrder == 'true' && parseInt(max_qty) > 0 ) {
     var cart_remaining =0;
      if(total_cart_quantity <= max_qty){
         var cart_remaining = max_qty - total_cart_quantity;
        var remaining_qty = qty_val - cart_remaining ;
      }else if(total_cart_quantity > max_qty){
         var remaining_qty = qty_val ;
      }else{
          var cart_remaining = max_qty - total_cart_quantity;
      
         var remaining_qty = qty_val - cart_remaining ;
      }
      if(remaining_qty > 0 ){
     // alert("hiii..."+remaining_qty+"==="+cart_remaining);
           $('.max_qty_preOder').attr('data-variant',main_pro_id);    
          $('.max_qty_preOder').addClass('active');
          $('.max_qty_preOder .input_qty').text(qty_val);
          $('.max_qty_preOder .inventory_qty').text(max_qty);
      
         $('.max_qty_preOder .remaining_qty').text(remaining_qty);
     
          $('.max_qty_preOder .cart_qty').text(total_cart_quantity +" items(s) are already in cart and");
         $('.max_qty_preOder .inventory_qty').attr('data-inventorytoAdd',qty_val);   
         $('.max_qty').removeClass('active');
          flag = '1';
           if(page =='cart'){
            $('.max_qty .confirmation_box').hide();
             $('.max_qty .cart_confirmation_box').show();
            //$('.QuantitySelector__CurrentQuantity1[data-id="'+main_pro_id+'"]').val(qty_val);
            
          }
      return false;
      }
        }    
  }  
      if(flag == '1'){
      return false;
    }
  
  }
});
*/
    
    if(parseInt(qty_val) > parseInt(max_qty) && check_preOrder == 'true' && parseInt(max_qty) > 0) {
      var remaining_qty = qty_val - max_qty ;
      $('.max_qty_preOder').attr('data-variant',main_pro_id);    
      $('.max_qty_preOder').addClass('active');
      $('.max_qty_preOder .input_qty').text(qty_val);
      $('.max_qty_preOder .inventory_qty').text(max_qty);
      $('.max_qty_preOder .remaining_qty').text(remaining_qty);
     $('.max_qty_preOder .inventory_qty').attr('data-inventorytoAdd',qty_val);   
     $('.max_qty').removeClass('active');
      flag = '1';
       if(page =='cart'){
        $('.max_qty .confirmation_box').hide();
         $('.max_qty .cart_confirmation_box').show();
        //$('.QuantitySelector__CurrentQuantity1[data-id="'+main_pro_id+'"]').val(qty_val);
        
      }
    }
    if(parseInt(qty_val) > parseInt(max_qty) && $.trim(check_preOrder) != 'true') {
       $(".max_qty").addClass("cart-drawer");
     $('.max_qty').attr('data-variant',main_pro_id); 
      $('.max_qty').addClass('active');
      $('.max_qty_preOder').removeClass('active');
      $('.max_qty').addClass('active');
      $('.max_qty .input_qty').text(qty_val);
      $('.max_qty .inventory_qty').text(max_qty); 
      $('.max_qty .inventory_qty').attr('data-inventorytoAdd',max_qty);     
      if(page =='cart'){
        $('.max_qty .confirmation_box').hide();
         $('.max_qty .cart_confirmation_box').show();
         var newQTY =parseInt($.trim($('.QuantitySelector__CurrentQuantity1[data-id="'+main_pro_id+'"]').attr('data-qty')));  
         $('.QuantitySelector__CurrentQuantity1[data-id="'+main_pro_id+'"]').val(newQTY); 
       // $('.QuantitySelector__CurrentQuantity1[data-id="'+main_pro_id+'"]').val(qty_val -1);
      }
      flag = '1';
    } 
    if(flag == '1'){
      return false;
    }else{
       return true;
    }
    
  }
  
  function setCookieNew(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookieNew(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
 